import { gql } from '@apollo/client';
import WDT_STUDENT_SETTINGS_FRAGMENT from 'graph/fragments/wdt-student-settings';

const WDT_STUDENT_SETTINGS = gql`
  query wdtStudentSettingsReport($studentId: Int!) {
    wdtStudentSettings(where: { studentId: $studentId }) {
      ...BaseWdtStudentSettings
    }
    student(where: { id: $studentId }) {
      classrooms {
        id
      }
    }
  }
  ${WDT_STUDENT_SETTINGS_FRAGMENT}
`;

export default WDT_STUDENT_SETTINGS;
